<template>
  <div class="gameSection">
    <Spinner v-if="loadingMore" :loadingMore="loadingMore" />
    <div
      v-else
      class="gameSection py-3 px-4 d-flex justify-content-center align-items-center"
      @click="emit('loadMore')"
    >
      <div class="gameSection-header-text text-center">
        Show more
        <font-awesome-icon
          :icon="faChevronDown"
          class="ml-1 font-weight-light"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import Spinner from '@/components/global/Spinner.vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons/faChevronDown';

const props = defineProps({
  loadingMore: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['loadMore']);
</script>

<style scoped lang="scss">
@use '@/scss/tokens.scss' as main;

.gameSection {
  border-radius: 6px;
  cursor: pointer;
  box-shadow: 0 2px 4px 0 main.$blue-1200;
  background-color: main.$white_07;

  &-header {
    color: main.$color-primary;
    cursor: pointer;
  }

  &-text {
    color: main.$color-primary_01;
    margin: 0;
    width: 100%;
    font-weight: main.$font-weight-light;
    font-size: main.$font-size-base;
  }
}

.gameSection-header-text {
  color: main.$color-primary_01;
  font-weight: main.$font-weight-light;
}
</style>
